<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>

import VueTypes from "vue-types";

import {ItemUpgradeMode} from "@/modules/redactor/models/item/upgrade/ItemUpgradeMode";

export default {
  name: "r-item-upgrade-mode",
  props: {
    model: VueTypes.instanceOf(ItemUpgradeMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemUpgradeMode.getValues();
    }
  }
}
</script>